import styled from "styled-components";

export const BannerWrapper = styled.section`
  .banner-container {
    position: relative;
    /* height: 100vh; */
    min-height: 700px;
  }
  .bannerContentWrapper {
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
    height: 100vh;
    min-height: 700px;
    .caption-sub-heading {
      font-size: 36px;
      margin-inline-end: 10px;
    }
    .caption-snd-heading {
      margin-bottom: 40px;
    }
    .caption-heading-main,
    .caption-snd-heading {
      font-size: 65px;
    }
  }

  .banner-bg {
    // position: absolute;
    // right: 0;
    // top: 30%;
    max-width: 640px;
    border-radius: 12px;
  }
  .text-styled {
    position: relative;
    right: 15px;
    top: 10px;
  }
  .down-btn {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 10;
    width: 90px;
    bottom: -10px;
  }
  .audio-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    body.rtl & {
      right: unset;
      left: 10px;
    }
  }
  @media (max-width: 1399px) {
    .banner-bg {
      max-width: 550px;
    }
  }
  @media (max-width: 1199px) {
    .banner-bg {
      max-width: 450px;
    }
  }
  @media (max-width: 991px) {
    .banner-bg {
      max-width: 100%;
    }
    .bannerContentWrapper {
      height: auto;
      min-height: auto;
      flex-wrap: wrap;
      padding-top: 120px;
      padding-bottom: 100px;
      .caption-sub-heading {
        font-size: 35px;
      }
      .caption-snd-heading {
        margin-bottom: 10px;
        font-size: 50px;
      }
      .caption-heading-main {
        font-size: 50px;
        line-height: 1.3;
      }
      .banner-content .bannerMan {
        width: 430px;
        bottom: -10px;
      }
    }
    .contactWrapper {
      button {
        gap: 8px;
        height: 46px;
        padding: 0px 10px;
        span {
          font-size: 16px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .bannerContentWrapper {
      .banner-content .bannerMan {
        width: 380px;
      }
      .caption-sub-heading {
        font-size: 28px;
      }
      .caption-snd-heading {
        font-size: 40px;
      }
      .caption-heading-main {
        font-size: 40px;
      }
    }
  }
  @media (max-width: 575px) {
    .bannerContentWrapper {
      padding-bottom: 10px;
      .banner-content .bannerMan {
        width: 330px;
        left: auto;
      }
    }
  }
  @media (max-width: 380px) {
    .bannerContentWrapper {
      .banner-content .bannerMan {
        width: 300px;
        bottom: 0px;
        right: -32px;
      }
    }
  }
`;

export const AudioOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
  cursor: pointer;
  color: white;
  font-size: 20px;
  font-weight: 600;
`;
